const Sparkline = ({
  data,
  comparisonData,
  width = 30,
  height = 30,
  color = '#0066cc',
  strokeWidth = 1.5,
  fill = false,
  showDots = false,
  className = ''
}) => {
  const { points, pointsArray, comparisonPoints } = useMemo(() => {
    if (!data || data.length === 0) return { points: '', pointsArray: [], comparisonPoints: '' };

    // Use shared scale when comparison data exists
    const allValues = comparisonData ? [...data, ...comparisonData] : data;
    const min = Math.min(...allValues);
    const max = Math.max(...allValues);
    const range = max - min || 1;

    const padding = 2;
    const effectiveWidth = width - padding * 2;
    const effectiveHeight = height - padding * 2;

    const toPoints = (values) => values.map((y, i) => {
      const x = (i / (values.length - 1)) * effectiveWidth + padding;
      const scaledY = effectiveHeight - ((y - min) / range) * effectiveHeight + padding;
      return { x, y: scaledY };
    });

    const pointsArray = toPoints(data);
    const compPointsArray = comparisonData ? toPoints(comparisonData) : [];

    return {
      points: pointsArray.map(p => `${p.x},${p.y}`).join(' '),
      pointsArray,
      comparisonPoints: compPointsArray.map(p => `${p.x},${p.y}`).join(' ')
    };
  }, [data, comparisonData, width, height]);

  if (!data || data.length === 0) {
    return <div className={className} style={{ width, height, display: 'inline-block' }} />;
  }

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
    >
      {comparisonPoints && (
        <polyline
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          points={comparisonPoints}
          opacity={0.3}
        />
      )}
      {fill ? (
        <polygon
          fill={color}
          fillOpacity="0.3"
          stroke={color}
          strokeWidth={strokeWidth}
          points={`${points} ${width-2},${height-2} 2,${height-2}`}
        />
      ) : (
        <polyline
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          points={points}
        />
      )}

      {showDots && pointsArray.map((point, i) => (
        <circle
          key={i}
          cx={point.x}
          cy={point.y}
          r={strokeWidth}
          fill={color}
        />
      ))}
    </svg>
  );
};

export default Sparkline;
